import { API_CALL } from '../../../../middleware/api';

export const PLOT_DATA = 'plot-data';
export const PLOT_DATA_RESULT = `${PLOT_DATA}/result`;
export const PLOT_DATA_ERROR = `${PLOT_DATA}/error`;

export const ALERT_DEFINITION_PUT = 'alert-definition-put';
export const ALERT_DEFINITION_PUT_RESULT = `${ALERT_DEFINITION_PUT}/result`;
export const ALERT_DEFINITION_PUT_ERROR = `${ALERT_DEFINITION_PUT}/error`;

export const ALERT_DEFINITION_GET = 'alert-definition-get';
export const ALERT_DEFINITION_GET_RESULT = `${ALERT_DEFINITION_GET}/result`;
export const ALERT_DEFINITION_GET_ERROR = `${ALERT_DEFINITION_GET}/error`;

export const ALERT_DEFINITION_DELETE = 'alert-definition-delete';
export const ALERT_DEFINITION_DELETE_RESULT = `${ALERT_DEFINITION_DELETE}/result`;
export const ALERT_DEFINITION_DELETE_ERROR = `${ALERT_DEFINITION_DELETE}/error`;


export const ALERTS_GET = 'alerts-get';
export const ALERTS_GET_RESULT = `${ALERTS_GET}/result`;
export const ALERTS_GET_ERROR = `${ALERTS_GET}/error`;

export const GOALS_GET = 'goals-get';
export const GOALS_GET_RESULT = `${GOALS_GET}/result`;
export const GOALS_GET_ERROR = `${GOALS_GET}/error`;

export const GOALS_PUT = 'goals-put';
export const GOALS_PUT_RESULT = `${GOALS_PUT}/result`;
export const GOALS_PUT_ERROR = `${GOALS_PUT}/error`;

export const GOALS_DELETE = 'goals-delete';
export const GOALS_DELETE_RESULT = `${GOALS_DELETE}/result`;
export const GOALS_DELETE_ERROR = `${GOALS_DELETE}/error`;

export const actions = {
  getPlotData: pageRequest => {
    const { patientId, dataType, startDate, endDate, resolution } = pageRequest;
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/data/${dataType}`,
        method: 'get',
        params: { startDate, endDate, resolution },
      },
      type: PLOT_DATA,
    };
  },
  setAlertDefinition: (patientId, alertDefinition) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/alert-definition`,
        method: 'put',
        data: alertDefinition,
      },
      type: ALERT_DEFINITION_PUT,
    };
  },
  getAlertDefinition: (patientId, type) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/alert-definition/${type}`,
        method: 'get',
      },
      type: ALERT_DEFINITION_GET,
    };
  },
  deleteAlertDefinition: (patientId, type) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/alert-definition`,
        method: 'delete',
        params: { type },
      },
      type: ALERT_DEFINITION_DELETE,
    };
  },
  getAlerts: patientId => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/alerts`,
        method: 'get',
      },
      type: ALERTS_GET,
    };
  },
  getGoals: (patientId, type, params) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/vitals-goal/${type}`,
        method: 'get',
        params,
      },
      type: GOALS_GET,
    };
  },
  setGoals: (patientId, type, goals) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/vitals-goal`,
        method: 'put',
        data: goals,
      },
      type: GOALS_PUT,
    };
  },
  deleteGoal: (patientId, type) => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/${patientId}/vitals-goal`,
        method: 'delete',
        params: { type },
      },
      type: GOALS_DELETE,
    };
  },
};
